import React from "react";
import Div from "@jumbo/shared/Div";
import { Link } from "react-router-dom";
import { ASSET_CODINGPAL } from "../../utils/constants/paths";
import { Typography, Box } from "@mui/material";
import { ROUTES } from "app/utils/constants/routeConstants";

const Logo = ({ mini, sx }) => {
  return (
    <Div sx={{ display: "inline-flex", ...sx }}>
      <Link to={ROUTES.USER_HOME} style={{ textDecoration: "none" }}>
        {!mini ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              direction: "row",
            }}
          >
            <img
              src={`${ASSET_CODINGPAL}/codingpal.jpg`}
              alt="CodingPal"
              width={40}
              height={40}
            />
            {!mini && (
              <Typography
                variant="h3"
                color="white"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  marginBottom: 0,
                }}
              >
                CodingPal
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              direction: "row",
            }}
          >
            <img
              src={`${ASSET_CODINGPAL}/codingpal.jpg`}
              alt="CodingPal"
              width={40}
              height={40}
            />
          </Box>
        )}
      </Link>
    </Div>
  );
};

Logo.defaultProps = {
  mode: "light",
};

export default Logo;
